import { XMarkIcon } from "@heroicons/react/24/outline";
import { Button } from "../Button";

export const ClearSearchButton = props => {
  const { onClick } = props || {};

  return (
    <Button
      action="default"
      ariaLabel="Clear search"
      className="!w-auto gap-1 !text-xs"
      customPadding="px-2 py-1"
      icon={<XMarkIcon className="h-4 w-4" aria-hidden="true" />}
      label="Clear"
      onClick={onClick}
    />
  );
};
